import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import * as _ from 'lodash';
import { TranslateService } from '../../services/translate/translate.service';
import { ContentService } from '../../services/content/content.service';

@Pipe({
  name: 'contentWeather'
})
export class ManMadeWeatherPipe implements PipeTransform {

  constructor(private contentService: ContentService, private translate: TranslateService) {
  }

  transform(entry: Models.ContentEntry): Models.ManMadeWeatherEntry | any {
    if (!entry || !entry.detail) {
      return null;
    }
    if (entry.detail.dates) {
      const forecastDays = entry.detail.dates;
      let days = [];
      for (const day in forecastDays) {
        if (!forecastDays.hasOwnProperty(day)) {
          continue;
        }
        const forecast = forecastDays[day].hour;

        let intervals = [];
        for (let hour in forecast) {
          if (!forecast.hasOwnProperty(hour)) {
            continue;
          }
          const intervalData = forecast[hour];

          let interval: any = {};
          interval = {
            fromTimestamp: intervalData.hour,
            icon: intervalData.icon,
            maxDegrees: intervalData.temperature,
            minDegrees: intervalData.temperature,
            windSpeed: intervalData.windspeed_min,
            maxWindSpeed: intervalData.windspeed_max,
            rainAmount: Number.parseFloat(intervalData.precipitation_sum),
            rainPosibility: Number.parseFloat(intervalData.precipitation_probability),
            snowAmount: Number.parseFloat(intervalData.snow_sum_3h)
          };
          intervals.push(interval);
        }
        intervals = _.orderBy(intervals, ['fromTimestamp']);
        let contentDay: any = {};
        let icon = intervals[0].icon;
        let dateNow = new Date();
        let dayDate = new Date(day);
        // let degree = intervals[0].maxDegrees;
        if ((dateNow.getMonth() === dayDate.getMonth()) && (dateNow.getDate() === dayDate.getDate())) {
          for (let i = 0; i < intervals.length; i++) {
            if (parseInt(intervals[i].fromTimestamp) <= dateNow.getHours()) {
              if (intervals[i + 1]) {
                if (parseInt(intervals[i + 1].fromTimestamp) > dateNow.getHours()) {
                  icon = intervals[i].icon;
                  // degree = intervals[i].maxDegrees;
                }
              } else {
                icon = intervals[i].icon;
              }
            }
          }
        }
        contentDay = {
          intervals,
          timestamp: day,
          sunAmount: forecastDays[day].sunshine_duration_sum,
          precipitationSum: forecastDays[day].precipitation_sum,
          snowSum: forecastDays[day].snow_sum,
          icon: forecastDays[day].symbolday ? `https://ibex3.ibexfusion.com/import/imports/engadinstmoritz/srfmeteo/stm_weather_icon/stm_weather_big_${forecastDays[day].symbolday}.svg` : icon,
          degrees: forecastDays[day].temperature_2m_max_12h
        };
        days.push(contentDay);
      }
      const res = { days };
      return res;
    }
    if (entry.detail.astronomie) {
      let dateNow = new Date();
      let dateObj = {};
      let i = 0;
      while (i < 7) {
        dateObj[dateNow.getFullYear() + '-' + ((+dateNow.getMonth() + 1) < 10 ? '0' + (+dateNow.getMonth() + 1) : (+dateNow.getMonth() + 1)) + '-' + (+dateNow.getDate() < 10 ? '0' + dateNow.getDate() : dateNow.getDate())] = {};
        dateNow.setDate(dateNow.getDate() + 1);
        i++;
      }
      let keys = Object.keys(dateObj);
      let forecasts = {};
      if (entry.detail.forecasts) {
        let forecastsKeys = Object.keys(entry.detail.forecasts);
        for (let f = 0; f < forecastsKeys.length; f++) {
          if (entry.detail.forecasts[forecastsKeys[f]][0] && entry.detail.forecasts[forecastsKeys[f]][0].valid &&
            entry.detail.forecasts[forecastsKeys[f]][0].valid.date) {
            let forecastsDate = new Date(entry.detail.forecasts[forecastsKeys[f]][0].valid.date);
            let dateKey = forecastsDate.getFullYear() + '-' + ((+forecastsDate.getMonth() + 1) < 10 ? '0' + (+forecastsDate.getMonth() + 1) : (+forecastsDate.getMonth() + 1)) + '-' + (+forecastsDate.getDate() < 10 ? '0' + forecastsDate.getDate() : forecastsDate.getDate());
            forecasts[dateKey] = {};
            let forecastsData = entry.detail.forecasts[forecastsKeys[f]];
            let forecastsDataKey = Object.keys(entry.detail.forecasts[forecastsKeys[f]]);
            for (let k = 0; k < forecastsDataKey.length; k++) {
              if (forecastsData[forecastsDataKey[k]] && forecastsData[forecastsDataKey[k]].temperature_2m_min_12h) {
                forecasts[dateKey].temperature_2m_min_12h = forecastsData[forecastsDataKey[k]].temperature_2m_min_12h;
              }
              if (forecastsData[forecastsDataKey[k]] && forecastsData[forecastsDataKey[k]].temperature_2m_max_12h) {
                forecasts[dateKey].temperature_2m_max_12h = forecastsData[forecastsDataKey[k]].temperature_2m_max_12h;
              }
              if (forecastsData[forecastsDataKey[k]] && forecastsData[forecastsDataKey[k]].symbol && !forecastsData[forecastsDataKey[k]].type) {
                forecasts[dateKey].icon = forecastsData[forecastsDataKey[k]].icon;
              }
              if (forecastsData[forecastsDataKey[k]] && forecastsData[forecastsDataKey[k]].type && forecastsData[forecastsDataKey[k]].type === 'vormittag') {
                forecasts[dateKey].morning = { icon: forecastsData[forecastsDataKey[k]].icon };
              }
              if (forecastsData[forecastsDataKey[k]] && forecastsData[forecastsDataKey[k]].type && forecastsData[forecastsDataKey[k]].type === 'nachmittag') {
                forecasts[dateKey].afternoon = { icon: forecastsData[forecastsDataKey[k]].icon };
                forecasts[dateKey].evening = { icon: forecastsData[forecastsDataKey[k]].icon };
              }
            }

          }
        }
      }
      let lang = this.translate.getCurrentLanguage();
      for (let i = 0; i < keys.length; i++) {
        dateObj[keys[i]].date = new Date(keys[i]);
        dateObj[keys[i]].key = keys[i];
        if (entry.detail.astronomie[keys[i]]) {
          dateObj[keys[i]] = Object.assign(dateObj[keys[i]], entry.detail.astronomie[keys[i]]);
        }
        if (entry.detail.ortewetter && entry.detail.ortewetter.dates) {
          dateObj[keys[i]] = Object.assign(dateObj[keys[i]], entry.detail.ortewetter.dates[keys[i]]);
        }
        if (forecasts && forecasts[keys[i]]) {
          dateObj[keys[i]] = Object.assign(dateObj[keys[i]], forecasts[keys[i]]);
        }
        if (entry.detail.textprognose && entry.detail.textprognose[i]) {
          dateObj[keys[i]] = Object.assign(dateObj[keys[i]], entry.detail.textprognose[i]);
        }
        // if (entry.detail.textprognose && entry.detail.textprognose[i]) {
        //   dateObj[keys[i]] = Object.assign(dateObj[keys[i]], entry.detail.textprognose[i]);
        // }
        if (entry.detail.textprognosebylanguage && entry.detail.textprognosebylanguage[lang] &&
          entry.detail.textprognosebylanguage[lang][i]) {
          dateObj[keys[i]] = Object.assign(dateObj[keys[i]], entry.detail.textprognosebylanguage[lang][i]);
        }
        if (dateObj[keys[i]].hour && dateObj[keys[i]].hour['18'] && dateObj[keys[i]].hour['18'].icon && dateObj[keys[i]].evening) {
          dateObj[keys[i]].evening.icon = dateObj[keys[i]].hour['18'].icon;
        }
        if (dateObj[keys[i]] && !dateObj[keys[i]].icon && dateObj[keys[i]].symbolday) {
          dateObj[keys[i]].icon = `https://ibex3.ibexfusion.com/import/imports/engadinstmoritz/srfmeteo/stm_weather_icon/stm_weather_big_${dateObj[keys[i]].symbolday}.svg`;
        }
      }
      let result = {
        type: 'region',
        dates: dateObj,
        updated: entry.detail.updated,
        author: entry.detail.author
      }
      return result;
    }
    return null;
  }
}
